import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import HomePage from '@/pages/HomePage';
import ConfirmationPage from '@/pages/ConfirmationPage';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminClinicas from '@/pages/AdminClinicas';
import AdminCatalogo from '@/pages/AdminCatalogo';
import AdminReportes from '@/pages/AdminReportes';
import AdminUsuarios from '@/pages/AdminUsuarios';
import SolicitudDetail from '@/pages/SolicitudDetail';
import ClinicaLogin from '@/pages/ClinicaLogin';
import ClinicaDashboard from '@/pages/ClinicaDashboard';
import ClinicaSolicitudForm from '@/pages/ClinicaSolicitudForm';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import ResultadoViewer from '@/pages/ResultadoViewer';
import SolicitudConfirmacion from '@/pages/SolicitudConfirmacion';
import PagoCancelado from '@/pages/PagoCancelado';
import PagoExitoso from '@/pages/PagoExitoso';
import { CatalogoPublicoPage, CatalogoEmbedPage } from '@/pages/CatalogoPublico';
import '@/App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Main entry - Clinic Login */}
          <Route path="/" element={<ClinicaLogin />} />
          
          {/* Public form (no registration required) */}
          <Route path="/solicitud-publica" element={<HomePage />} />
          <Route path="/confirmacion" element={<ConfirmationPage />} />
          
          {/* Public PDF viewer */}
          <Route path="/resultado/:id" element={<ResultadoViewer />} />
          
          {/* Public Catalog */}
          <Route path="/catalogo" element={<CatalogoPublicoPage />} />
          <Route path="/catalogo/embed" element={<CatalogoEmbedPage />} />
          
          {/* Admin routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/clinicas" element={<AdminClinicas />} />
          <Route path="/admin/catalogo" element={<AdminCatalogo />} />
          <Route path="/admin/reportes" element={<AdminReportes />} />
          <Route path="/admin/usuarios" element={<AdminUsuarios />} />
          <Route path="/admin/solicitud/:id" element={<SolicitudDetail />} />
          
          {/* Clinic routes */}
          <Route path="/clinica/login" element={<ClinicaLogin />} />
          <Route path="/clinica/dashboard" element={<ClinicaDashboard />} />
          <Route path="/clinica/nueva-solicitud" element={<ClinicaSolicitudForm />} />
          <Route path="/clinica/solicitud/:id" element={<SolicitudDetail />} />
          <Route path="/clinica/forgot-password" element={<ForgotPassword />} />
          <Route path="/clinica/reset-password" element={<ResetPassword />} />
          <Route path="/clinica/confirmacion/:id" element={<SolicitudConfirmacion />} />
          <Route path="/clinica/pago-exitoso" element={<PagoExitoso />} />
          <Route path="/clinica/pago-cancelado" element={<PagoCancelado />} />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;